import axiosInstance from "../utils/axios";
import {
  UpdateDirectDebitDto,
  DirectDebit,
  CreateDirectDebitDto,
} from "../@types/direct-debits";

export class DirectDebitsService {
  /**
   * STEP 1: Create Direct Debit with GoCardless customer
   */
  async createWithCustomer(data: { patientId: string }) {
    const response = await axiosInstance.post(
      "/direct-debits/create-with-customer",
      data,
    );
    return response.data;
  }

  /**
   * STEP 2: Initiate redirect flow for bank account setup
   */
  async initiateRedirectFlow(data: {
    directDebitId: string;
    successRedirectUrl: string;
  }) {
    const response = await axiosInstance.post(
      "/direct-debits/initiate-redirect-flow",
      data,
    );
    return response.data;
  }

  /**
   * STEP 3: Save payment plan configuration
   */
  async savePaymentPlan(data: {
    directDebitId: string;
    paymentFrequency: string;
    paymentAmountType: string;
    paymentAmount: number | null;
    startDate: string;
    paymentReference: string;
  }) {
    const response = await axiosInstance.post(
      "/direct-debits/save-payment-plan",
      data,
    );
    return response.data;
  }

  /**
   * STEP 4: Record mandate acceptance
   */
  async recordAcceptance(data: {
    directDebitId: string;
    understandsMandate: boolean;
    acknowledgesGuarantee: boolean;
    willProvideConfirmation: boolean;
    confirmsAccuracy: boolean;
  }) {
    const response = await axiosInstance.post(
      "/direct-debits/record-acceptance",
      data,
    );
    return response.data;
  }

  /**
   * STEP 5: Complete redirect flow
   */
  async completeRedirectFlow(data: {
    directDebitId: string;
    redirectFlowId: string;
  }) {
    const response = await axiosInstance.post(
      "/direct-debits/complete-redirect-flow",
      data,
    );
    return response.data;
  }

  /**
   * Get all direct debits
   */
  async getAll() {
    const response = await axiosInstance.get("/direct-debits");
    return response.data;
  }

  /**
   * Get a specific direct debit by ID (for restoration)
   */
  async getDirectDebit(id: number) {
    const response = await axiosInstance.get(`/direct-debits/${id}`);
    return response;
  }

  /**
   * Get one direct debit
   */
  async getOne(id: number) {
    const response = await axiosInstance.get(`/direct-debits/${id}`);
    return response.data;
  }

  /**
   * Cancel mandate
   */
  async cancelMandate(id: number) {
    const response = await axiosInstance.post(`/direct-debits/${id}/cancel`);
    return response.data;
  }

  /**
   * Delete direct debit
   */
  async delete(id: number) {
    const response = await axiosInstance.delete(`/direct-debits/${id}`);
    return response.data;
  }
}
